import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Levente Varga </span>
            from <span className="purple"> Debrecen, Hungary.</span>
            <br />
            I am currently employed as a system administrator.
            <br />
            I am currently studying to become an IT engineer at the Faculty of Informatics of the University of Debrecen.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight/> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight/> Creating Game Servers
            </li>
            <li className="about-activity">
              <ImPointRight/> Playing Airsoft and Paintball
            </li>
            <li className="about-activity">
              <ImPointRight/> Cooking/Grilling
            </li>
          </ul>

          <p style={{color: "rgb(155 126 172)"}}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">Soumyajit</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
